import { gql } from '@apollo/client';
const SET_WAREHOUSE_RELEASE_MODEL_TO_NOT_READY = gql `
  mutation SetWarehouseReleaseModelToNotReady($warehouseReleaseModelId: String!) {
    setWarehouseReleaseModelToNotReady(warehouseReleaseModelId: $warehouseReleaseModelId) {
      warehouseReleaseModel {
        id
      }
    }
  }
`;
export default SET_WAREHOUSE_RELEASE_MODEL_TO_NOT_READY;
